<template>
  <div class="main">
    <img src="https://img.1234567.com.cn/libs/repository/bg.png"
    class="mainback" />
  </div>
</template>

<script>

export default {
  name: '',
  components: {
  },
  data() {
    return {
      loadUrl: 'https://act.1234567.com.cn/topic/repository/fund-toapp-page/openmp.html?fundcode=000001',
    };
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {
    render() {
    },
  },
};
</script>

<style scoped lang="less">
.main{
}
.mainback{

  height: 100%;
  width: 100%;
}
.wrap{
  display: flex;
  border-radius: 12px;
  height: 100%;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
